export function gridRefresh(grid) {
    grid.ParentObject.refreshGrid(grid.ControlName);
}
export function gridSort(grid, columnId, sortDirection) {
    const column = grid.getColumnByHtmlName(columnId);
    grid.setSort(column.index, sortDirection !== "desc");
}
